module.exports = __webpack_public_path__ + "static/media/newicon.6c65555d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/TabBar/newicon.gif
// module id = 782
// module chunks = 0